import PropTypes from 'prop-types'

export const FooterSettings = PropTypes.shape({
  navigation: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.objectOf({
          _type: PropTypes.string,
          heading: PropTypes.string,
        }),
        PropTypes.objectOf({
          _type: PropTypes.string,
          text: PropTypes.string,
          url: PropTypes.string,
        }),
      ]),
    ),
  ),
})
